import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-header d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 3 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des commandes fournisseurs", -1)),
      _createElementVNode("div", null, [
        (_ctx.checkPermission('AddCommandeFournisseur'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'AddCommandeFournisseurPage' },
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                _createTextVNode(" Nouvelle commande ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Mot clé", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                type: "text",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Référence ou fournisseur"
              }, null, 512), [
                [_vModelText, _ctx.searchTerm]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Statut", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStatut) = $event)),
                class: "form-select shadow-none fs-md-15 text-black"
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Tous", -1)),
                _createElementVNode("option", { value: _ctx.STATUT_EN_ATTENTE }, "En attente de validation", 8, _hoisted_10),
                _createElementVNode("option", { value: _ctx.STATUT_VALIDE }, "Validée", 8, _hoisted_11),
                _createElementVNode("option", { value: _ctx.STATUT_REJETE }, "Rejetée", 8, _hoisted_12)
              ], 512), [
                [_vModelSelect, _ctx.selectedStatut]
              ])
            ])
          ]),
          (_ctx.point_ventes.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Filtrer par point de vente", -1)),
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.point_vente,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.point_vente) = $event)),
                    options: _ctx.point_ventes,
                    searchable: true,
                    label: "label",
                    placeholder: "Sélectionner un point de vente"
                  }, null, 8, ["modelValue", "options"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("table", _hoisted_16, [
          _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Référence"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Date"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Fournisseur "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Poids total "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, "Statut"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              }, " Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commandes, (commande) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: commande.id
              }, [
                _createElementVNode("td", _hoisted_17, _toDisplayString(commande.refCom), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.format_date(commande.dateComFrs)), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.libelleFournisseur(commande.fournisseur)), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.formatPoids(commande.poidsTotal)), 1),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.classeStatut(commande.statut)])
                  }, _toDisplayString(_ctx.libelleStatut(commande.statut)), 3)
                ]),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[15] || (_cache[15] = _createElementVNode("button", {
                      class: "btn dropdown-toggle btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_24, [
                      (_ctx.checkPermission('ViewCommandeFournisseur'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                            _createVNode(_component_router_link, {
                              to: { name: 'ViewCommandeFournisseurPage', params: { id: commande.id } },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode("Détails ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('DownloadBordereauCommandeFournisseur'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                            _createElementVNode("a", {
                              href: "javascript:void(0)",
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.imprimerBordereau(commande))
                            }, _cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "fa fa-print lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode("Bordereau ")
                            ]), 8, _hoisted_27)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.estEnAttente(commande))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.checkPermission('EditCommandeFournisseur'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'EditCommandeFournisseurPage', params: { id: commande.id } },
                                    class: "dropdown-item d-flex align-items-center"
                                  }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode("Modifier ")
                                    ])),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPermission('ValidateCommandeFournisseur'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "dropdown-item d-flex align-items-center",
                                    onClick: ($event: any) => (_ctx.valider(commande))
                                  }, _cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "fa fa-check lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode("Valider ")
                                  ]), 8, _hoisted_30)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPermission('RejectCommandeFournisseur'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "dropdown-item d-flex align-items-center",
                                    onClick: ($event: any) => (_ctx.rejeter(commande))
                                  }, _cache[13] || (_cache[13] = [
                                    _createElementVNode("i", { class: "fa fa-ban lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode("Rejeter ")
                                  ]), 8, _hoisted_32)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.checkPermission('DeleteCommandeFournisseur'))
                              ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "dropdown-item d-flex align-items-center",
                                    onClick: ($event: any) => (_ctx.supprimer(commande))
                                  }, _cache[14] || (_cache[14] = [
                                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode("Supprimer ")
                                  ]), 8, _hoisted_34)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.commandes.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_35, _cache[16] || (_cache[16] = [
                  _createElementVNode("td", {
                    colspan: "6",
                    class: "text-center text-body-tertiary py-4"
                  }, "Aucune commande fournisseur trouvée.", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}